<template>
  <div class="order">
    <div class="head-list">
      <div v-for="(item, index) in headList" :key="index">
        <div class="num">{{item.value}}</div>
        <div class="text">{{item.name}}{{item.unit}}</div>
      </div>
    </div>
    <div class="line1">
      <div class="content w-30">
        <div class="top"><div class="icon"></div>平台订单数量统计（单位：万元）</div>
        <div class="title">
          <div v-for="(item, index) in topOrderQuantityOfSysSourceSummary" :key="index">{{(item.transaction / 10000).toFixed(2)}}万元</div>
          <!-- <div>销售总金额：1000万</div>
          <div>订单笔数：10000单</div> -->
        </div>
        <div id="order-charts1"></div>
      </div>
      <div class="content w-70">
        <div class="top"><div class="icon"></div>月订单统计</div>
        <!-- <div class="title">
          <div>销售总金额：1000万</div>
          <div>订单笔数：10000单</div>
        </div> -->
        <div id="order-charts2"></div>
      </div>
    </div>
    <div class="line2">
      <div class="content w-30 h-770">
        <div class="top clearfix"><div class="icon"></div>店铺销售额TOP10<em>（单位：元）</em></div>
        <!-- <div class="title">
          <div>销售总金额：1000万</div>
          <div>订单笔数：10000单</div>
        </div> -->
        <div id="order-charts3">
          <div class="item" v-for="(item, index) in list" :key="index">
            <div class="top">
              <div :style="{'background': item.color}" class="index">{{index + 1}}</div>
              <div class="name">{{item.accountName}}</div>
              <!-- <div v-if="menuItem.searchOrderStoreRating" class="unit">店铺评分</div> -->
              <!-- @click="getScope(item)" -->
            </div>
            <div class="bottom">
              <div :style="{'background': item.color, 'width': item.width}" class="line"></div>
              <div :style="{'color': item.color}">{{ item.transaction }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="content w-70 h-770">
        <div class="top"><div class="icon"></div>商品销售额排行</div>
        <!-- <div class="title">
          <div>销售总金额：1000万</div>
          <div>订单笔数：10000单</div>
        </div> -->
        <div>
          <div class='ux-tabs tabs' style="margin:0 40px;
            width:calc(100% - 80px);margin-top:24px;min-height:100px">
            <div class="ux-filter-records filter-records">
              <div class='content-list' style="height:auto">
                <el-table
                  class="table ux-dark-el-table"
                  empty-text="暂无数据"
                  :data="tableData1"
                  element-loading-spinner="el-icon-loading">
                    <el-table-column show-overflow-tooltip v-for="(props, i) in tableHeader1" :label='props.label' align="center" :key="i">
                      <template slot-scope="scope">
                        <div v-if="props.type">
                       {{ scope.row.rank }}
                        </div>
                        <template class="text" v-else>
                          {{ scope.row[props.prop] | isEmptyVal }}
                        </template>
                      </template>
                    </el-table-column>
                    <!-- <el-table-column v-if="menuItem.searchOrderProductRating" label='商品评分' align="center">
                      <template slot-scope="scope">
                        <div class="blue setCursor" @click="getScope(scope.row)">评分分析</div>
                      </template>
                    </el-table-column> -->
                </el-table>
              </div>
              <div class='pages' style="margin-top: 24px">
                <span>共 {{ page1.total }} 条数据</span>
                <el-pagination
                  class="ux-dark-el-pagination"
                  small
                  background
                  layout="prev, pager, next"
                  :current-page="page1.current"
                  :page-size="page1.size"
                  :total="page1.total"
                  @current-change="currentChange1"
                />
                <pagination @currentChange="currentChange1" @sizeChange="sizeChange1"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="line1">
      <div class="content w-100">
        <div class="top"><div class="icon"></div>订单明细</div>
        <div>
          <div class='ux-tabs tabs' style="margin:0 40px;
            width:calc(100% - 80px);margin-top:16px;min-height:100px">
            <div class="ux-filter-records filter-records">
              <div class='content-list' style="height:auto">
                <el-table
                  v-loading="initChart5Loading"
                  class="table ux-dark-el-table"
                  :data="tableData2"
                  max-height="360"
                  empty-text="暂无数据"
                  element-loading-spinner="el-icon-loading">
                    <el-table-column v-for="(props, i) in tableHeader2" :label='props.label' align="center" :key="i" show-overflow-tooltip>
                      <template slot-scope="scope">
                        <div v-if="props.type">
                          {{scope.$index + 1}}
                        </div>
                        <div v-else>
                          <div class="text" style="position:relative" v-if="props.tips">{{ scope.row[props.prop] }}
                            <el-popover
                              placement="right"
                              title=""
                              width="200"
                              trigger="click">
                              <div>
                                <p>服务费：{{tipsModelInfo.serviceCharge || 0 | formatNumber}} 元</p>
                                <p>广告费：{{tipsModelInfo.advertisingExpenses || 0 | formatNumber}} 元</p>
                                <p>库存费和入库服务费：{{tipsModelInfo.inventoryWarehousingServiceFee || 0 | formatNumber}} 元</p>
                                <p>交易佣金：{{tipsModelInfo.transactionCommission || 0 | formatNumber}} 元</p>
                                <p>配送费：{{tipsModelInfo.shippingPrice || 0 | formatNumber}} 元</p>
                                <p>其他费用：{{tipsModelInfo.otherCharge || 0 | formatNumber}} 元</p>
                              </div>
                              <img slot="reference" style="width:30px;height:30px;position: absolute;top:-5px;right:8px;cursor: pointer;" src='@/assets/images/common/icon-gth.png' @click="showTips(scope.row)"/>
                            </el-popover>
                          </div>
                          <template class="text" v-else>
                            <template v-if="props.prop === 'orderStatus'">
                               {{setOrderStatus(scope.row.orderStatus) }}
                            </template>
                            <template v-else>
                              {{ scope.row[props.prop] }}
                            </template>
                          </template>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope" align="center">
                        <span style="color: rgb(71,166,234)" class="setCursor" @click.stop="toDetail(scope.row, 'dd')">查看详情</span>
                      </template>
                    </el-table-column>
                </el-table>
              </div>
              <div class='pages'>
                <span>共 {{ page2.total }} 条数据</span>
                <el-pagination
                  class="ux-dark-el-pagination"
                  small
                  background
                  layout="prev, pager, next"
                  :current-page="page2.current"
                  :page-size="page2.size"
                  :total="page2.total"
                  @current-change="currentChange2"
                />
                <pagination @currentChange="currentChange2" @sizeChange="sizeChange2"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="商品列表"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class='commonDialog'
      :visible.sync="modelShow"
      width="80%"
    >
      <div class='mask'></div>
      <div class='ux-panel'>
        <div class='title'>商品列表</div>
        <div class="head-list">
          <div v-for="(item, index) in headList" :key="index">
            {{item.name}}{{item.value}}{{item.unit}}
          </div>
        </div>
        <div class='ux-tabs tabs'>
          <div class="ux-filter-records filter-records">
            <div class='content-list'>
              <el-table
                class="table ux-dark-el-table"
                :data="scoretableData"
                empty-text="暂无数据"
                element-loading-spinner="el-icon-loading">
                  <el-table-column v-for="(props, i) in scoretableHeader" :label='props.label' align="center" :key="i" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <template v-if="props.type">
                        {{((page.current - 1) * page.size) + scope.$index + 1}}
                      </template>
                      <template v-else>
                        <template class="text">{{ scope.row[props.prop] }}</template>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column width="120" label='商品评分' align="center">
                    <template slot-scope="scope">
                      <div class="blue">商品评分</div>
                    </template>
                  </el-table-column>
              </el-table>
            </div>
            <div class='pages'>
              <span>共 {{ scorepage.total }} 条数据</span>
              <el-pagination
                class="ux-dark-el-pagination"
                small
                background
                layout="prev, pager, next"
                :current-page="scorepage.current"
                :page-size="scorepage.size"
                :total="scorepage.total"
                @current-change="scorecurrentChange"
              />
              <pagination @currentChange="scorecurrentChange" @sizeChange="scoresizeChange"/>
            </div>
          </div>
        </div>
        <div class='close' @click='modelShow = false'>
          <img src='@/assets/images/home/close.png'/>
          <!-- <CircleClose style="width: 32px; height: 32px;color: #fff"/> -->
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import common from '@/utils/common'
// import languageObj from '@/utils/lan.json'
import pagination from '@/components/main/bigData/home/compontents/pagination.vue'
import apiPath from '@config/api.json'
import { Loading } from 'element-ui'
const {mapState, mapMutations} = require('vuex')
// const customsStatusJson = {
//   '1': '已清关',
//   '2': '待清关',
//   '3': '清关中'
// }
export default {
  components: { pagination },
  props: ['info'],
  data () {
    return {
      menuItem: {
        searchOrderProductRating: false, // 搜索-查看订单-评分分析
        searchOrderStoreRating: false // 搜索-查看订单-店铺评分
      },
      modelShow: false,
      scoretableData: [],
      scoretableHeader: [
        {
          type: 'index',
          label: '序号'
        },
        {
          prop: 'productId',
          label: '商品ID'
        },
        {
          prop: 'productName',
          label: '商品名称'
        },
        {
          prop: 'productPrice',
          label: '售价（元）'
        },
        {
          prop: 'tradeTotalAmount',
          label: '销售总额（元）'
        },
        {
          prop: 'productQuantity',
          label: '销量（件）'
        },
        {
          prop: 'shopName',
          label: '所属店铺'
        },
        {
          prop: 'sysSource',
          label: '所属平台'
        },
        {
          prop: 'tradeTotalAmount',
          label: '销售总金额'
        }
      ],
      scorepage: {
        current: 1,
        size: 10,
        total: 0
      },
      scpreinfo: {},
      tableHeader1: [
        {
          type: 'index',
          label: '排名'
        },
        {
          prop: 'sku',
          label: '商品sku'
        },
        {
          prop: 'productName',
          label: '商品名称'
        },
        {
          prop: 'productPrice',
          label: '售价（元）'
        },
        {
          prop: 'transaction',
          label: '销售总额（元）'
        },
        {
          prop: 'salesNum',
          label: '销量（件）'
        },
        {
          prop: 'accountName',
          label: '所属店铺'
        },
        {
          prop: 'platform',
          label: '所属平台'
        }
        // {
        //   prop: 'waybillQuantity',
        //   label: '商品评分'
        // }
      ],
      tableData1: [],
      tableHeader2: [
        {
          type: 'index',
          label: '序号'
        },
        {
          prop: 'orderId',
          label: '订单编号'
        },
        {
          prop: 'platform',
          label: '所属平台'
        },
        {
          prop: 'accountName',
          label: '店铺'
        },
        {
          prop: 'salesNum',
          label: '商品数量（个）'
        },
        {
          prop: 'orgName',
          label: '承运人'
        },
        {
          prop: 'customerNumber',
          label: '运单编号'
        },
        // {
        //   prop: 'totalExpenses',
        //   label: '费用支出明细（元）',
        //   tips: true
        // },
        {
          prop: 'orderStatus',
          label: '订单状态'
        },
        {
          prop: 'purchaseDate',
          label: '订单日期'
        }
      ],
      tableData2: [],
      headList: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      page1: {
        current: 1,
        size: 10,
        total: 0
      },
      page2: {
        current: 1,
        size: 10,
        total: 0
      },
      list: [],
      colors: ['rgb(236,154,86)', 'rgb(230,202,95)', 'rgb(107,215,156)', 'rgb(138,63,243)', 'rgb(81,163,192)', 'rgb(66,101,203)', 'rgb(53,54,180)', 'rgb(149,78,220)', 'rgb(187,143,182)', 'rgb(206,108,118)'],
      summary: {},
      tipsModel: false,
      tipsModelInfo: {},
      topOrderOfMmSummary: {},
      topOrderOfShopSummarySummary: {},
      topOrderQuantityOfSysSourceSummary: [],
      filter: {
        'pageNum': 1,
        'pageSize': 10,
        'searchDate': '',
        'searchParam': '',
        'sortParam': '',
        'yearTime': '2022'
      },
      topOrderSummary: [], // 总订单
      topOrderReturnSummary: [], // 退货单
      initChart5Loading: false
    }
  },

  computed: {
    ...mapState({
      searchDate: (state) => {
        return state.home.searchDate
      }
    })
  },

  watch: {
    searchDate: function (n) {
      this.init()
    }
  },

  created () {
    this.getOrderSalesSummary()
    // this.setLanguageMsg(this.lan)
    const getListMenu = common.getListMenu()
    if (getListMenu) {
      const setListMenu = window.JSON.parse(getListMenu)
      this.menuItem.searchOrderProductRating = common.isShowItem('searchOrderProductRating', setListMenu)
      this.menuItem.searchOrderStoreRating = common.isShowItem('searchOrderStoreRating', setListMenu)
    }
  },

  mounted () {
    this.init()
  },

  methods: {
    setOrderStatus (orderStatus) {
      return common.orderStatus(orderStatus)
    },
    ...mapMutations({}),
    setTransaction (val) {
      return (val / 10000).toFixed(2)
    },
    init () {
      this.getInfo()
      this.getOrderOfMmStatistics()
      // this.initChart1()
      // this.initChart2()
      // this.initChart3()
      this.initChart4()
      this.initChart5()
    },
    getOrderSalesSummary () {
      this.$ajax({
        method: 'get',
        url: `${apiPath.bigData.search.order.getOrderSalesSummary}/${this.info.customerNo}`
        // url: `${apiPath.bigData.search.order.getOrderSalesSummary}/AABK`
      }).then(res => {
        if (res.data) {
          let data = res.data || {}
          this.headList = [
            {
              name: '销售总额',
              value: data.transaction || '0',
              unit: '（元）'
            }, {
              name: '订单笔数',
              value: data.orderNum || '0',
              unit: '（单）'
            }, {
              name: '商品总量',
              value: data.productNum || '0',
              unit: '（个）'
            }, {
              name: '在售商品数量',
              value: data.saleProductNum || '0',
              unit: '（个）'
            }, {
              name: '商品销量',
              value: data.salesNum || '0',
              unit: '（件）'
            }, {
              name: '主体数量',
              value: data.sellerNum || '0',
              unit: '（家）'
            }, {
              name: '平台数量',
              value: data.platformNum || '0',
              unit: '（个）'
            }, {
              name: '授权店铺',
              value: data.authStoresNum || '0',
              unit: '（家）'
            }
          ]
        }
      })
    },
    getInfo () {
      this.$ajax({
        method: 'get',
        url: `${apiPath.bigData.search.listConcentration}/${this.info.customerNo}`
        // url: `${apiPath.bigData.search.listConcentration}/AAA4`
      }).then(res => {
        if (res && res.data) {
          let dataInfo = res.data
          this.summary = dataInfo.summary
          // this.topOrderOfMmSummary = dataInfo.topOrderOfMmSummary
          this.topOrderQuantityOfSysSourceSummary = dataInfo.top10List || []
        }
        this.initChart1()
        // this.initChart2()
        this.initChart3()
      })
    },
    initChart1 () {
      let sysSource = this.topOrderQuantityOfSysSourceSummary.map(item => { return item.platform + '(单)' })
      let orderQuantity = this.topOrderQuantityOfSysSourceSummary.map(item => { return item.orderNum })
      var chartDom = document.getElementById('order-charts1')
      var myChart = this.$echarts.init(chartDom)
      let option
      option = {
        tooltip: {},
        xAxis: {
          type: 'category',
          data: sysSource,
          axisLabel: {
            textStyle: {
              color: '#fff'
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            textStyle: {
              color: '#fff'
            }
          }
        },
        series: [
          {
            data: orderQuantity,
            type: 'bar'
          }
        ]
      }
      option && myChart.setOption(option)
    },
    getOrderOfMmStatistics () {
      let dataInfo = []
      this.$ajax({
        method: 'get',
        url: `${apiPath.bigData.search.jygl.getOrderSalesTrend}/${this.info.customerNo}`
        // url: `${apiPath.bigData.search.jygl.getOrderSalesTrend}/AABK`
      }).then(res => {
        if (res && res.data) {
          dataInfo = res.data
        }
        this.initChart2(dataInfo)
      })
    },
    initChart2 (dataInfo) {
      let monthTime = dataInfo.map(item => { return item.monthDay })
      let orderQuantitys = dataInfo.map(item => { return item.transaction })
      let returnQuantitys = dataInfo.map(item => { return item.returnNum })
      var chartDom = document.getElementById('order-charts2')
      var myChart = this.$echarts.init(chartDom)
      let data = ['总订单', '退货单']
      let option
      option = {
        legend: {
          data: data,
          textStyle: {
            color: '#fff'
          }
        },
        tooltip: {
          formatter: function (params) {
            return params.marker + params.seriesName + ' : ' + params.value + '单'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLabel: {
            textStyle: {
              color: '#fff'
            }
          },
          data: monthTime
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            textStyle: {
              color: '#fff'
            }
          }
        },
        series: [
          {
            data: orderQuantitys,
            type: 'line',
            name: data[0],
            emphasis: {
              focus: 'series'
            },
            smooth: true,
            lineStyle: {
              width: 0
            },
            areaStyle: {
              opacity: 0.8,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgb(128, 255, 165)'
                },
                {
                  offset: 1,
                  color: 'rgb(1, 191, 236)'
                }
              ])
            }
          },
          {
            data: returnQuantitys,
            type: 'line',
            name: data[1],
            emphasis: {
              focus: 'series'
            },
            smooth: true,
            lineStyle: {
              width: 0
            },
            areaStyle: {
              opacity: 0.8,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgb(0, 115, 265)'
                },
                {
                  offset: 1,
                  color: 'rgb(111, 98, 036)'
                }
              ])
            }
          }
        ]
      }
      option && myChart.setOption(option)
    },
    initChart3 () {
      this.$ajax({
        method: 'get',
        url: `${apiPath.bigData.search.jygl.getEnterpriseAccount}/${this.info.customerNo}`
        // url: `${apiPath.bigData.search.getEnterpriseAccount}/AABK`
      }).then(res => {
        if (res && res.data) {
          this.topOrderOfShopSummarySummary = res.data.top10List
          let list = []
          let width = 600
          this.topOrderOfShopSummarySummary.forEach((item, index) => {
            item.color = this.colors[index]
            list.push(item)
          })
          let nums = list.map(item => {
            item.tradeTotal = Number(item.transaction)
            return item.tradeTotal
          })
          let max = Math.max.apply(null, nums)
          list.map(item => {
            item.width = ((item.transaction / max) * width) + 'px'
          })
          this.list = list.slice(0, 10)
          this.list.sort((a, b) => b.transaction - a.transaction)
        }
      })
    },
    toDetail (row, type) {
      this.$emit('detail', {row: row, type: type})
    },
    initChart4 () {
      const loadTips = Loading.service()
      this.$ajax({
        method: 'post',
        url: `${apiPath.bigData.search.order.getProductEnterpriseSales}`,
        data: {
          'companyName': this.info.companyName,
          'pageNum': this.page1.current,
          'pageSize': this.page1.size,
          'searchDate': this.searchDate,
          'customerNo': this.info.customerNo
        }
      }).then(res => {
        loadTips.close()
        if (res) {
          const dataInfo = res.data || {}
          this.page1.total = dataInfo.total || 0
          this.tableData1 = dataInfo.records || []
        }
      })
    },
    initChart5 () {
      this.initChart5Loading = true
      this.$ajax({
        method: 'post',
        url: `${apiPath.bigData.search.order.getSalesOrder}`,
        data: {
          'pageNum': this.page2.current,
          'pageSize': this.page2.size,
          customerNo: this.info.customerNo
          // 'searchDate': this.searchDate
        }
      }).then(res => {
        this.initChart5Loading = false
        if (res) {
          this.page2.total = res.data.total || 0
          this.tableData2 = res.data.records || []
        }
      })
    },
    currentChange1 (e) {
      this.page1.current = e
      this.initChart4()
    },
    sizeChange1 (e) {
      this.page1.current = 1
      this.page1.size = e
      this.initChart4()
    },
    currentChange2 (e) {
      this.page2.current = 1
      this.page2.current = e
      this.initChart5()
    },
    sizeChange2 (e) {
      this.page2.current = 1
      this.page2.size = e
      this.initChart5()
    },
    getScope (item) {
      this.scpreinfo = item
      this.getScopeList()
    },
    getScopeList () {
      const loadTips = Loading.service()
      this.$ajax({
        method: 'post',
        url: `${apiPath.bigData.search.listScoringAnalysis}`,
        data: {
          'productName': this.scpreinfo.productName,
          'companyName': this.info.companyName,
          'pageNum': this.scorepage.current,
          'pageSize': this.scorepage.size,
          'searchDate': this.searchDate,
          'searchParam': '',
          'sortParam': '',
          'yearTime': this.searchDate
        }
      }).then(res => {
        loadTips.close()
        if (res) {
          this.scoretableData = res.data || []
          this.scorepage.total = res.total || 0
        }
        this.modelShow = true
      })
    },
    scorecurrentChange (e) {
      this.scorepage.current = e
      this.getScopeList()
    },
    scoresizeChange (e) {
      this.scorepage.current = 1
      this.scorepage.size = e
      this.getScopeList()
    },
    showTips (data, e) {
      this.$ajax({
        method: 'post',
        url: apiPath.bigData.search.getExpensesDetail,
        data: {
          'id': data.id,
          'companyName': this.info.companyName,
          'pageNum': 1,
          'pageSize': 10,
          'searchDate': this.searchDate,
          'searchParam': '',
          'sortParam': '',
          'yearTime': this.searchDate
        }
      }).then(res => {
        if (res && res.data) {
          this.tipsModelInfo = res.data
        } else {
          this.tipsModelInfo = {}
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
  .order{
    .head-list{
      display: flex;
      margin-top: 30px;
      margin-bottom: 24px;
      justify-content: space-around;
      flex-wrap: wrap;
      padding: 0 150px;
      color:#fff;
      font-size:24px;
      .num{
        color: rgb(71,166,234);
        font-size:24px;
        line-height: 40px;
        text-align: center;
      }
      .text{
        font-size:18px;
        line-height: 24px;
      }
    }
    .content{
      border: 1px solid rgb(71,166,234);
      border-radius: 6px;
      padding: 16px 20px 32px 20px;
      margin:32px 0 16px 0;
      .top{
        display: flex;
        font-size:18px;
        // margin-bottom: 10px;
        .icon{
          width: 20px;
          height: 20px;
          border-radius: 4px;
          background: rgb(71,166,234);
          margin-right:16px;
        }
      }
      .title{
        text-align: center;
        display: flex;
        justify-content: space-around;
        padding: 0 100px;
        font-size:18px;
        margin-top: 20px;
      }
    }
    .line1{
      display: flex;
      height: 440px;
      margin-bottom:72px;
      margin-left:30px;
    }
    .line2{
      display: flex;
      height: 656px;
      margin-bottom:72px;
      margin-left:30px;
    }
    .w-70{
      width: 1050px;
      height: 100%;
      // margin-left:32px;
    }
    .w-30{
      width: 710px;
      height: 100%;
      margin-right:20px;
      margin-left:0;
    }
    .w-100{
      width: calc(100% - 70px);
      height: 100%;
      // margin-right:32px;
      // margin-left:32px;
    }
    #order-charts1 {
      width: 100%;
      height: 390px;
      // margin-top: 16px;
    }
    #order-charts2 {
      width: 100%;
      height: 390px;
      margin-top: 16px;
    }
    #order-charts3 {
      margin:16px 32px 16px 32px;
      height: 700px;
      .item{
        margin-bottom:9px;
        color:#fff;
        font-size:12px;
        .top{
          display: flex;
          align-items: center;
          font-size:16px;
        }
        .index{
          width: 24px;
          height:24px;
          line-height:24px;
          text-align: center;
          border-radius: 50%;
          margin-right: 16px;
        }
        .name{
          margin-right: 16px;
          min-width: 100px;
        }
        .unit{
          color: rgb(71,166,234);
        }
        .bottom{
          font-size:18px;
          display: flex;
          align-items: center;
          margin: 6px 0 6px 46px;
        }
        .line{
          height:16px;
          border-radius: 10px;
          min-width: 20px;
          margin-right: 10px;
        }
      }
    }
    #fee-tips{
      position: absolute;
      right: 40px;
      top:0;
      z-index: 999;
      // background: rgba(255, 255, 255, 0.4);
      // color:#fff;
      background: #fff;
      color:#000;
      font-size:16px;
      padding: 4px 16px;
      min-width:140px;
      border-radius: 4px;
      // height:100px;
      div{
        height:30px;
        line-height: 30px;
      }
    }
  }
</style>
<style lang='scss'>
  .commonDialog{
    // width: 1410px;
    // height: 810px;
    margin-top: 0;
    margin-bottom: 0;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2018;
    position: absolute;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
    .el-dialog__header{
      display: none;
      padding:0;
    }
    .el-dialog__body{
      position: relative;
      padding: 0;
      height: 100%;
    }
    .mask{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      cursor: pointer;
      border-radius: 0px;
      background: rgba(0, 0, 0, 0.5);
    }
    .ux-panel{
      position: relative;
      z-index: 1;
      padding-top: 70px;
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      border: 1px solid #22bdfe;
      background: rgba(17, 47, 72, 0.9);
      .head-list{
        display: flex;
        margin-top: 32px;
        justify-content: space-around;
        flex-wrap: wrap;
        padding: 0 150px;
        color:#fff;
        font-size:24px;
        div{
          margin-bottom: 8px;
        }
      }
      .title{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 70px;
        line-height: 70px;
        text-align: center;
        font-size: 24px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        background: linear-gradient(180deg, #eeeeee 0%, #4dc5ff 100%);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .title::after {
        position: absolute;
        content: "";
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: calc(100% - 30px * 2);
        height: 0;
        border: 1px solid;
        border-image: linear-gradient(63deg, rgba(71, 241, 255, 0), #38c2ff, rgba(34, 222, 254, 0)) 1 1;
      }
      .tabs{
        padding: 0 30px;
        box-sizing: border-box;
        .tabs-header{
          // margin-bottom:20px;
          text-align: center;
        }
        .tabs-header {
          .ux-dark-el-radio {
            .is-active,
            .is-focus {
              span {
                color: #ffffff;
                box-shadow: -1px 0 0 0 #1c8be2;
                border-color: #1c8be2;
                background-color: #1c8be2;
              }
            }
            span {
              padding: 9px 12px;
              font-size: 16px;
              font-family: SourceHanSansCN-Regular, SourceHanSansCN;
              font-weight: 400;
              color: #2bb0f0;
              border-color: #2d6bab;
              background: rgba(24, 127, 215, 0.2);
            }
          }
          .el-radio-button__inner{
            margin: 0 4px;
            padding: 10px 12px;
            font-size: 18px;
            border-radius: 0px 0px 4px 4px;
            color: #2bb0f0;
            border: 1px solid #2d6bab;
            background: rgba(24, 127, 215, 0.2);
          }
          .el-radio-group{
            font-size: 0
          }
        }
        .tabs-pane {
          .el-tabs {
            .el-tabs__header {
              display: none;
            }
          }
          .ux-table-wrap {
          }
        }
        table {
          .cell {
            padding: 12px 10px;
          }
          .el-table__cell{
             border-right: 1px solid #2d6bab;
             border-bottom: 1px solid #2d6bab;
          }
          th .cell {
            text-align: center;
            font-size: 18px !important;
          }
        }
      }
      .close{
        position: absolute;
        right: 20px;
        top: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: content-box;
        padding: 5px;
        width: 24px;
        height: 24px;
        cursor: pointer;
        img{
          width: 30px;
          height: 30px;
        }
      }
    }
    .ux-filter-records {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding: 20px 30px 0;
    box-sizing: border-box;
    .filter {
      display: flex;
      flex-wrap: wrap;
      // div {
      //   margin-right: 18px;
      //   margin-bottom: 10px;
      // }
      .search {
        color: #ffffff;
        background: #1c8be2;
      }
    }
    .content-list {
      margin-top: 10px;
      flex: none;
      // min-height: 550px;
      .table {
        height: 100%;
        .el-table__header-wrapper {
          tr {
            th {
              height: 50px;
            }
          }
        }
        .el-table__body-wrapper {
          tr {
            td {
              height: 50px;
            }
          }
        }
        .el-loading-mask {
          /* background: rgba(0, 0, 0, 0.8); */
          .el-loading-spinner {
            font-size: 24px;
          }
        }
        .text {
          font-size: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
      }
      .ux-dark-el-table {
        display: flex;
        flex-direction: column;
        border: 1px solid #2d6bab;
        background-color: transparent;
        table {
          tr {
            background: rgba(24, 127, 215, 0.1) !important;
            &:last-child {
              td {
                border-bottom: none;
              }
            }
            th {
              padding: 0;
              border-color: #2d6bab !important;
              background: rgba(24, 127, 215, 0.3) !important;
              &:last-child {
                border-right: none;
              }
              .cell {
                font-size: 16px;
                font-family: SourceHanSansCN-Medium, SourceHanSansCN;
                font-weight: 500;
                color:#fff;
                // background: linear-gradient(180deg, #eeeeee 0%, #4dc5ff 100%);
                // background-clip: text;
                // -webkit-text-fill-color: transparent;
              }
            }
            td {
              padding: 0;
              font-size: 14px;
              font-family: SourceHanSansCN-Medium, SourceHanSansCN;
              font-weight: 500;
              color: #ffffff;
              border-color: #2d6bab;
              &:last-child {
                border-right: none;
              }
            }
          }
        }
        td.el-table__cell{
          border-bottom: 1px solid #2d6bab;
        }
        &::before {
          display: none;
        }
        // tbody row hover
        &.el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
          background: rgba(24, 127, 215, 0.2);
        }
        // 多级表头
        &.el-table--group::after,
        // 带边框表格
        &.el-table--border::after {
          content: unset;
        }
        .el-table__body-wrapper {
          flex: 1 1;
          table {
            height: 100%;
          }
        }
        .el-table__footer-wrapper tbody td.el-table__cell {
          font-size: 16px;
          background-color: transparent;
        }
      }
    }
    .pages {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      height: 28px;
      font-size: 16px;
      font-weight: 400;
      color: #fff;
    }
  }
  }
  .el-input-dark {
    .el-input__inner{
      height: 36px;
      line-height: 36px;
      font-size: 16px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #ffffff;
      border: 1px solid #2d6bab;
      background: rgba(24, 127, 215, 0.2);
      padding: 0 15px !important;
    }
    .search {
        color: #ffffff;
        background: #1c8be2;
    }
    .el-input__wrapper{
      padding: 0 !important;
      margin-bottom:0 !important;
      box-shadow: none !important;
    }
    .el-input--suffix{
      margin-bottom:0 !important;
    }
    .el-input__suffix {
      right: 5px;
      transition: all .3s;
      position: absolute;
      top: 0;
      height: 100%;
      color: #C0C4CC;
      text-align: center;
    }
    .select-trigger{
      margin-bottom:0 !important;
    }
  }
  .el-btn-dark{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80px;
    height: 36px;
    font-size: 16px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #2bb0f0;
    border: 1px solid #2d6bab;
    background: transparent;
    &:focus,
    &:hover {
      color: #2bb0f0;
      border-color: #2d6bab;
      background: transparent;
    }
  }
  .ux-dark-el-pagination {
    padding-right: 0;
    .btn-prev,
    .el-pager li,
    .el-pager li:last-child,
    .el-pager li.active,
    .btn-next {
      min-width: 28px !important;
      min-height: 28px !important;
      line-height: 26px !important;
      font-size: 16px !important;
      color: #ffffff !important;
      border: 1px solid #2d95ea;
      background-color: transparent !important;
    }
    .el-pager li.active {
      background: #1c8be2 !important;
    }
    .btn-next {
      margin-right: 0 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/main/bigData/search/compontents/order.vue